export default "__VITE_ASSET__019802a0__"